// extracted by mini-css-extract-plugin
export var btn = "index-module--btn--56608";
export var form = "index-module--form--1f0dd";
export var icon = "index-module--icon--e3572";
export var input = "index-module--input--ae57a";
export var submit = "index-module--submit--4a82e";
export var title = "index-module--title--d3003";